import loadable from '@loadable/component';

export const NewbuildingHeaderFullscreenGalleryContainerLoadable = loadable(
  () => import('./NewbuildingHeaderFullscreenGallery'),
);
